// https://willwillems.com/posts/store-design-in-svelte.html

import { get } from 'svelte/store'
import { Endpoint, Token, TokenError, TokenSuccess, checkToken, checkTokenComplete, setValidationErrors } from './store.js'
import { userPost, UserError, UserSuccess, checkUser, checkUserComplete  } from './store.js'

// https://evalkit.modum.io/?token=DLQFX&first_name=Hans&last_name=Meier&email=hans@meier.ch


export const TokenSubmit = async () => {
	checkToken()
	
	const token_value = get(Token).toUpperCase()
	await fetch(Endpoint + '?token=' + token_value)
		.then( response => response.json())
		.then( data => {
			if (data.token == 'valid') TokenSuccess()
			else TokenError(data)
		})

	checkTokenComplete()
}

export const postUser = async () => {
	checkUser();

	const user_data = get(userPost)
	await postData(Endpoint, user_data)
		.then( response => response.json())
		.then( data => {
			if (data.status === 200){
				UserSuccess()
			} else if (data.status === 409){
				UserError(data.message)
			} else if (data.status === 422){
				if (data.validation_errors){
					setValidationErrors(data.validation_errors)
				}
				if (data.errors){
					UserError(data.errors.token)
				}
			}
		})
		
	checkUserComplete();
}

const postData = async ( url = '', data = {}) => {
	const response = await fetch(url, {
		method: 'POST',
		mode: 'cors',
		headers: {
      'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	})
	return response
};